import { selectSessionStatus, sessionApi, type SessionStatus } from '@krp/client-runtime'

import type { RootState } from './types'

/** Статус сессии от корня состояния: один селектор на оболочку (вход, самовосстановление). */
export const selectStatus = (state: RootState): SessionStatus => selectSessionStatus(state.session)

/** Ответ «кто я» из кэша RTK Query. */
export const selectMe = sessionApi.endpoints.sessionMe.select()
